import React, { useContext, useEffect } from 'react'
import { useInstData } from 'tyan/public/hooks'
import { FormDataContext } from 'Tyan/public/components/context'
import Button from './Button'
import { getFlow } from './flowUtility'

const Flow = props => {
	const { config: { _flow: flow, disabled, onFinish, refreshStamp, param } = {} } = props
	const {
		me, me: { state: { acts = [] } },
		setState
	} = useInstData(props)

	const formData = useContext(FormDataContext) || {}
	const { onClose, onFlowFinished, id: formId = 0 } = { ...(formData.props || {}), ...(formData.state || {}) }
	const id = Object.keys(props.config || {}).includes('id') ? (props.config.id || 0) : formId
	// console.log('debug:', props, formData, id)

	useEffect(() => {
		!disabled && getFlow({ flow, id, param, onFinish, onClose, onFlowFinished })
			.then(({ /* errorMessage,  */acts }) => { setState({ acts }) })
	}, [flow, id, disabled, refreshStamp])

	return <>
		{acts.map((act, index) => {
			act.config.disabled = disabled
			return <Button key={`${act.act}_${index}_${refreshStamp}`} config={act.config} />
		})}
	</>
}
export default Flow